import type { AxiosError } from 'axios';
import axios from 'axios';

import type { ErrorCode } from './error-codes';

class ErrorMatcher {
  public static isAppError(
    error: unknown,
    code: ErrorCode | ErrorCode[]
  ): error is AxiosError<{
    errorCode: ErrorCode;
    message: string;
    details?: Record<string, unknown>;
  }> {
    const errorCode = Array.isArray(code) ? code : [code];

    if (axios.isAxiosError(error)) {
      return errorCode.includes(error.response?.data.errorCode);
    }

    return false;
  }

  public static isAbortErrorOrCanceledError(error: unknown) {
    if (axios.isCancel(error)) {
      return true;
    }

    return error instanceof Error && error.name === 'AbortError';
  }
}

export { ErrorMatcher };
